// extracted by mini-css-extract-plugin
export default {"header":"Header_header__kyOSo","title":"Header_title__pDzBe","desc":"Header_desc__VysNq","actions":"Header_actions__QdB8q"};